export default __webpack_public_path__ + "static/media/vip-brasil.72109505.ico";